<label class="switch">
  <!--suppress TypeScriptUnresolvedVariable -->
  <input (change)="valueChanged($event.target.checked)" [checked]="checked" type="checkbox">
  <span [ngClass]="{'round': round}" class="slider"></span>
</label>
